import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
  BooleanInput,
  // CheckboxGroupInput,
  // Filter,
  translate as t,
} from 'admin-on-rest';

import {
  TextField as TextFieldMd,
} from 'material-ui';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
// import ThumbnailField from '../components/fields/ThumbnailField';
// import ImageInput from '../components/inputs/ImageInput';
import SelectArrayInput from '../components/inputs/SelectArrayInput';
// import Section from '../components/utils/Section';
// import ThumbnailImageField from '../components/fields/ThumbnailImageField';
import References from '../components/References';
import UserPermissionInput from '../components/inputs/UserPermissionInput';
import { PhoneNumberFieldInput } from '../components/inputs/PhoneNumberInput';
import { regscape } from '../utils/StringUtils';

// const subscriptions = [
//   { id: 'drink', name: 'drink' },
//   { id: 'food', name: 'food' },
// ];

// const UserFilter = (props) => (
//   <Filter {...props}>
//     <TextInput label="Search" source="q" alwaysOn />
//   </Filter>
// );


class UserListCustom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
    };
  }

  searchUser = () => {
    const { data } = this.props;
    const { query } = this.state;

    const dataArray = Object.keys(data);

    if (query && query.length > 2) {
      const filteredIds = dataArray.filter((phone) => {
        const matchesName = new RegExp(regscape(query), 'gi').test(data[phone].fullName);
        const matchesNumber = new RegExp(regscape(query), 'gi').test(data[phone].phoneNumber);
        return matchesName || matchesNumber;
      });

      const dataObj = {};
      filteredIds.forEach((id) => dataObj[id] = data[id]); // eslint-disable-line no-return-assign

      return {
        ...this.props,
        data: dataObj,
        ids: filteredIds,
      };
    }
    return {
      ...this.props,
    };
  }

  handleSearchChange = (e, value) => this.setState({ query: value })

  render() {
    const { translate } = this.props;
    const filteredProps = this.searchUser();
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
          <TextFieldMd floatingLabelText={translate('query')} onChange={this.handleSearchChange} />
        </div>

        <Datagrid {...filteredProps}>
          <TextField source="fullName" />
          <TextField source="phoneNumber" />
          <EditButton {...filteredProps} basePath="/users" />
          <DeleteButton {...filteredProps} basePath="/users" />
        </Datagrid>
      </div>
    );
  }
}

export const UserList = t((props) => (
  <List
    {...props}
    perPage={999}
    // filters={<UserFilter />}
    // filter={
    //   !props.permissions.superUser && props.user.venues.length > 0
    //     ? (
    //       {
    //         venues: { $in: props.user.venues },
    //         role: [...props.permissions.subRoles, props.permissions.name],
    //       }
    //     ) : {}
    // }
  >
    <UserListCustom {...props} />
  </List>
));

// eslint-disable-next-line no-shadow
const UserTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.fullName }) : ''}</span>
));

const UserForm = (props) => (
  <SimpleForm {...props}>
    {props.edit ? (
      <TextField source="phoneNumber" />
    ) : (
      <PhoneNumberFieldInput source="phoneNumber" />
    )}
    <br />
    {/* <Section title="login">
      <TextInput source="username" options={{ autoComplete: 'new-username' }} />
      <TextInput type="password" format={() => null} source="password" options={{ autoComplete: 'new-password' }} />
    </Section> */}
    <TextInput source="fullName" options={{ autoComplete: 'new-fullName' }} />
    <TextInput source="email" type="email" options={{ autoComplete: 'new-email' }} />
    {/* <Section title="contact">
      <TextInput source="mobileNumber" type="tel" autoComplete="tel" />
    </Section> */}
    {/* {props.permissions.superUser && (
      <Section title="subscriptions">
        <CheckboxGroupInput
          label="emailSubscriptions"
          source="subscriptions"
          choices={subscriptions}
        />
      </Section>
    )} */}
    <BooleanInput source="superUser" />
    <BooleanInput source="helpAdmin" />
    <SelectInput
      source="area"
      allowEmpty
      choices={[
        { name: props.translate('news.north'), id: 'north' },
        { name: props.translate('news.central'), id: 'central' },
        { name: props.translate('news.south'), id: 'south' },
      ]}
      options={{ fullWidth: true }}
    />
    <References references={[{ name: 'roles' }, { name: 'venues' }]}>
      <UserPermissionInput {...props} />
    </References>
    {/* <ReferenceInput
      source="role"
      reference="roles"
      allowEmpty
      filter={
        !props.permissions.superUser && props.permissions.subRoles.length > 0
          ? (
            {
              _id: props.permissions.subRoles,
            }
          ) : {}
      }
    >
      <SelectInput options={{ fullWidth: true }} optionValue="id" optionText="name" />
    </ReferenceInput>
    <ReferenceArrayInput
      source="venues"
      reference="venues"
      allowEmpty
      filter={
        !props.permissions.superUser && props.user.venues.length > 0
          ? (
            {
              name: props.user.venues,
            }
          ) : {}
      }
    >
      <SelectArrayInput options={{ fullWidth: true }} source="venues" />
    </ReferenceArrayInput> */}
    <ReferenceInput source="market" reference="markets" allowEmpty>
      <SelectInput options={{ fullWidth: true }} optionText="countryCode" optionValue="id" />
    </ReferenceInput>
    <ReferenceArrayInput source="languages" reference="markets" allowEmpty>
      <SelectArrayInput options={{ fullWidth: true }} optionText="languageCodes[0]" optionValue="languageCodes[0]" />
    </ReferenceArrayInput>
  </SimpleForm>
);

export const UserEdit = (props) => (
  <Edit title={<UserTitle />} {...props}>
    <UserForm edit {...props} redirect="list" />
  </Edit>
);

export const UserCreate = (props) => (
  <Create {...props}>
    <UserForm {...props} redirect="list" />
  </Create>
);
